import type { FC } from 'react'

import Skeleton from '@mui/material/Skeleton'

type Props = {
  minWidth?: number
  maxWidth?: number
}

export const BreadcrumbSkeleton: FC<Props> = ({ minWidth = 60, maxWidth = 120 }) => {
  const width = Math.floor(Math.random() * (maxWidth - minWidth + 1)) + minWidth

  return (
    <Skeleton
      variant="text"
      width={width}
      sx={{
        display: 'inline-block',
        verticalAlign: 'middle',
        borderRadius: 1
      }}
    />
  )
}
